import { IZoneInitialState } from "../../../types/master/zoneInterface";
import { ZoneActionTypes, ZoneActions } from "../../actionTypes/master/zoneActionTypes";

const initialState: IZoneInitialState = {
  zoneList: [],
  zoneData: {
    id: 0,
    zone_name: "",
    slug: "",
    hub_code:  0,
    created_by: 0,
    state: [
      {
        id: 0,
        state_name: "",
        slug: "",
        createdAt: "",
        updatedAt: "",
        district: [
          {
            id: 0,
            district_name: "",
          },
        ],
      },
    ],
  },
  zoneListPageCount: 0,
};

export default function zoneReducer(state = initialState, action: ZoneActionTypes): IZoneInitialState {
  switch (action.type) {
    case ZoneActions.SET_ZONE_LIST:
      return {
        ...state,
        zoneList: action.payload,
      };

    case ZoneActions.SET_ZONE_LIST_PAGE_COUNT:
      return {
        ...state,
        zoneListPageCount: action.payload,
      };

    case ZoneActions.SET_ZONE_DATA_BY_ID:
      return {
        ...state,
        zoneData: action.payload,
      };

    default:
      return state;
  }
}
